export const parallax = () => {
  let parallax = document.querySelector('.parallax')
  let Parallax = require('parallax-js')
  new Parallax(parallax, {
    relativeInput: true,
    selector: '.layer',
  })
}
